import {
  Divider as NextUIDivider,
  type DividerProps,
} from "@nextui-org/react";

export function Divider(props: DividerProps) {
  return <NextUIDivider {...props} />;
}

export type { DividerProps };
